import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { FROM_DASHBOARD_CARD_PARAM } from '../utils';

export const useDashboardFromCardQueryParam = () => {
  const location = useLocation();

  const fromCard = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const fromCard = params.get(FROM_DASHBOARD_CARD_PARAM);
    return fromCard ? parseInt(fromCard, 10) : null;
  }, [location.search]);

  return fromCard;
};
